import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogProps,
    Grid,
} from '@mui/material'
import EditActionPanel from 'components/Form/EditActionPanel'
import React from 'react'
import AppDialogTitle from './AppDialogTitle'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import Warning from '@mui/icons-material/Warning'
import { useTranslation } from 'react-i18next'
import CloseDialogButton from './CloseDialogButton'

interface WarningDialogProps extends DialogProps {
    open: boolean

    /**
     * Dialog's title
     */
    title?: string

    /**
     * Callback function when clicked the confirmation button.
     * @returns
     */
    onSave: () => void

    /**
     * Callback function when clicked the discard button.
     * @returns
     */
    onDiscard: () => void
    children?: React.ReactNode
    options?: {
        /**
         * Text showing in the confirmation button.
         */
        confirmText?: string

        disabledConfirm?: boolean

        /**
         * TRUE will disabled all buttons.
         */
        disabledButton?: boolean

        /**
         * Text showing in the discard button
         */
        discardBtnText?: string
        hideConfirmBtn?: boolean
        hideCancelBtn?: boolean
    }
}

export default function WarningDialog({
    open,
    title,
    children,
    onSave,
    onDiscard,
    options,
    ...dialogProps
}: WarningDialogProps) {
    const { isMobile } = useScreenSize()
    const {
        confirmText,
        disabledConfirm,
        disabledButton,
        discardBtnText,
        hideConfirmBtn,
        hideCancelBtn,
    } = options ?? {}
    const { t } = useTranslation()
    return (
        <Dialog open={open} onClose={() => {}} {...dialogProps}>
            {title && <AppDialogTitle text={title} />}
            <CloseDialogButton
                dialogName="warning dialog"
                onClick={onDiscard}
            />
            <DialogContent sx={{ border: 'none' }}>
                <Grid
                    container
                    direction={'row'}
                    justifyContent={'center'}
                    spacing={3}
                    alignItems={'center'}
                >
                    <Grid item xs={'auto'}>
                        <Warning color="warning" sx={{ fontSize: '50px' }} />
                    </Grid>
                    <Grid item xs={10}>
                        {children}
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Box p={isMobile ? 0 : 2} pt={0} width={'100%'}>
                    <EditActionPanel
                        onSave={onSave}
                        onDiscard={onDiscard}
                        disabled={disabledButton}
                        saveDisabled={disabledConfirm}
                        saveText={confirmText || t('common.label.confirm')}
                        discardText={discardBtnText || t('common.label.back')}
                        hideConfirmBtn={hideConfirmBtn}
                        hideDiscardBtn={hideCancelBtn}
                        saveColor={'primary'}
                        fullButtons={dialogProps.fullScreen}
                        buttonHeight={
                            dialogProps.fullScreen ?? false ? 60 : undefined
                        }
                    />
                </Box>
            </DialogActions>
        </Dialog>
    )
}
